import { render } from "./Spotlight.vue?vue&type=template&id=34b94cd6&ts=true&lang=pug"
import script from "./Spotlight.vue?vue&type=script&setup=true&lang=ts"
export * from "./Spotlight.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__